import { OfferCard } from 'features/job-offers/list/components/grid/card';
import { useI18n } from 'hooks/useI18n';
import { UIOfferListItem } from 'interfaces/ui/ui-offer-list-item';
import { Fragment } from 'react';
import Masonry from 'react-masonry-css';
import Fade from 'react-reveal/Fade';
import { Heading2 } from '../../shared/Typography';
import { StyledPositions, StyledPositionsGrid } from './JoinUsPositions.styled';

type JoinUsPositionsProps = {
  offers: UIOfferListItem[];
};

const JoinUsPositions: React.FC<JoinUsPositionsProps> = ({ offers }) => {
  const { t } = useI18n('join-us');

  const breakpointColumnsObj = {
    default: 3,
    890: 2,
    550: 1
  };

  if (offers?.length <= 0) {
    return null;
  }

  return (
    <StyledPositions>
      <Heading2 editorial>{t('careers.title')}</Heading2>
      <StyledPositionsGrid>
        <Masonry
          breakpointCols={breakpointColumnsObj}
          className="masonry-grid"
          columnClassName="masonry-column"
        >
          {offers.map((offer, i) => (
            <Fragment key={i}>
              <Fade bottom distance="10px" ssrReveal={true}>
                <OfferCard offer={offer} />
              </Fade>
            </Fragment>
          ))}
        </Masonry>
      </StyledPositionsGrid>
    </StyledPositions>
  );
};

export default JoinUsPositions;
